import { defineStore } from "pinia";

export const useCheckoutStore = defineStore("checkout", {
  state: () => ({
    order: null,
    shippingMethod: null, // Add shippingMethod to store
  }),
  actions: {
    setOrder(order) {
      this.order = order;
    },
    setShippingMethod(method) {
      this.shippingMethod = method;
    },
    clearCheckout() {
      this.order = null;
      this.shippingMethod = null;
    },
  },
  persist: {
    storage: localStorage,
  },
});
